var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-crud',{attrs:{"crudName":"Usuários","newText":"Novo Usuário","table":_vm.userTable,"columns":_vm.columns,"options":_vm.options,"endPoint":_vm.endPoint,"enableAdd":true,"enableReset":true,"enableEdit":true,"enableDelete":true,"enableView":false,"dataForm":_vm.dataForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }